import axios from 'axios'
import router from '@/router';
import api from '@/api';

export const reportWaiterFfficiencyModule = {
    namespaced: true,

    state:() => ({
        reportData: {},
        reportLoading: true,
        filterset: {},
        filtersetLoading: true,
        filterSpecs: {},
        defaultDate: [],
        excelData: {},
    }),

    mutations: {
        setReportData(state, data) {
            state.reportData = data
        },

        setReportFilterset(state, data) {
            state.filterSpecs['date_range'] = []

            if(Object.keys(router.currentRoute.value.query).length == 0) {
                for(let filter in data) {
                    if(filter !== 'title') {
                        for(let i = 0; i < data[filter].choices.length; i++) {
                            if(filter === 'date_range') {
                                state.filterSpecs[filter].push(data[filter].choices[i].value)
                            }
                            else if(filter === 'time_range') {
                                state.filterSpecs[filter] = {
                                    hours: data[filter].choices[0].value.split(':')[0],
                                    minutes: data[filter].choices[0].value.split(':')[1],
                                    seconds: '00'
                                }
                            } else {
                                if(data[filter].choices[i].checked) {
                                    state.filterSpecs[filter] = data[filter].choices[i].value
                                }
                            }
                        }
                    }
                }
            } else {
                const queries = router.currentRoute.value.query
                for(let filter in data) {
                    if(data[filter].multi_choices) {
                        state.filterSpecs[filter] = []
                    } else {
                        state.filterSpecs[filter] = ''
                    }
                }
                queries.shop ? state.filterSpecs['shop'] = Number(queries.shop) : state.filterSpecs['shop'] = ''
                queries.mode ? state.filterSpecs['mode'] = queries.mode : state.filterSpecs['mode'] = ''
                queries.revenue ? state.filterSpecs['revenue'] = queries.revenue : state.filterSpecs['revenue'] = ''
                queries.week_days ? state.filterSpecs['week_days'] = Number(queries.week_days) : state.filterSpecs['week_days'] = ''


                state.filterSpecs['date_range'] = []
                queries.date_from ? state.filterSpecs['date_range'].push(queries.date_from) : state.filterSpecs['date_range'].push('')
                queries.date_to ? state.filterSpecs['date_range'].push(queries.date_to) : state.filterSpecs['date_range'].push('')

                if(queries.time_range) {
                    state.filterSpecs['time_range'] = {
                        hours: queries.time_range.split(':')[0],
                        minutes: queries.time_range.split(':')[1],
                        seconds: '00'
                    }
                }
            }
            console.log(state.filterSpecs);
            state.filterset = data
            console.log(state.filterset)
            state.filtersetLoading = false
        },

        setExcelData(state, data) {
            state.excelData = data
        },

        sortReportData(state, { id, asc }) {
            const array = state.reportData.rows
            
            array.sort((a, b) => {
                const valueA = a.find(item => item.id === id).value;
                const valueB = b.find(item => item.id === id).value;

                let comparison = 0;
                if (typeof valueA === 'string' && typeof valueB === 'string') {
                    comparison = valueA.localeCompare(valueB);
                } else {
                    comparison = valueA - valueB;
                }
                
                const data = asc ? comparison : -comparison
                return data;
            });
        }
    },

    actions: {
        async getReportData({ commit, state }) {
            state.reportLoading = true
            // Проверяет, есть ли параметры которые можно передать в запросе
            if(router.currentRoute.value.fullPath.split('?')[1]) {
                try {
                    const response = await axios.get(api + "reports/waiter_efficiency/data?" + router.currentRoute.value.fullPath.split('?')[1], {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    commit('setReportData', response.data.data)
                    commit('setExcelData', response.data)
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            // Если нет, делать запрос без параметров
            } else {
                try {
                    const response = await axios.get(api + "reports/waiter_efficiency/data", {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    commit('setReportData', response.data.data)
                    commit('setExcelData', response.data)
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            }

            state.reportLoading = false
        },

        async getReportFilterset({ commit, state }) {
            try {
                const response = await axios.get(api + "reports/waiter_efficiency/filterset", {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                console.log(response.data);
                commit('setReportFilterset', response.data)
                state.filtersetLoading = false
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },

        resetFilters({ state }) {
            for(let filter in state.filterset) {
                state.filterSpecs[filter] = []

                if(filter !== 'title') {
                    for(let i = 0; i < state.filterset[filter].choices.length; i++) {
                        if(filter === 'date_range') {
                            state.filterSpecs[filter].push(state.filterset[filter].choices[i].value)
                        } else {
                            if(state.filterset[filter].choices[i].checked) {
                                state.filterSpecs[filter] = state.filterset[filter].choices[i].value
                            }
                        }
                    }
                }
            }
        },

        async getExcelFile({ state }) {
            try {
                const response = await axios.post(api + "reports/export_to_excel/",
                state.excelData,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    },
                    responseType: 'blob'
                })

                const now = new Date()
                const url = URL.createObjectURL(response.data)
                const a = document.createElement('a')
                a.href = url
                a.download = `${state.excelData.title}_${now.toLocaleDateString()}.xls`
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                a.remove()
                URL.revokeObjectURL(url)
                
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },
    }
}